/**
 * Vigilancia do estado "analisando".
 *
 * O timeout do fetch nao basta: a linha pode ficar presa em `ai_status='processing'`
 * (tentativa abandonada, funcao que morreu no meio, corrida benigna que retornou cedo)
 * e entao o poll leria "processing" para sempre, prendendo a UI em "Gerando estrutura"
 * sem nenhuma saida. O usuario precisa cair em `analysis_failed` e ganhar o botao de
 * tentar novamente — o servidor permite roubar o lease depois de 90s de qualquer forma.
 */

/** Um pouco maior que o AI_PROCESSING_TIMEOUT_MS para nao competir com o proprio servidor. */
export const AI_ANALYZING_STALE_MS = 100_000;

export const isAiProcessingStale = (
  aiStartedAt: string | null | undefined,
  nowMs: number,
  staleAfterMs: number = AI_ANALYZING_STALE_MS,
): boolean => {
  if (!aiStartedAt) return false;

  const startedAtMs = new Date(aiStartedAt).getTime();
  if (Number.isNaN(startedAtMs)) return false;

  return nowMs - startedAtMs > staleAfterMs;
};
